<template lang="html">
  <el-drawer
    title="Detalle de Solicitud"
    :visible.sync="drawer"
    :with-header="true"
    size="60%"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <label style="font-weight: bold; margin-bottom: 105px">
              Descripción Corta</label
            >
            <el-input
              type="textarea"
              :rows="3"
              disabled
              placeholder="Descripción Aquí"
              v-model="descripcionCorta"
            >
            </el-input>
          </el-col>
        </el-row>

        <el-row style="margin-bottom: 105px">
          <el-col>
            <label style="font-weight: bold; margin-bottom: 105px">
              Más Detalles</label
            >
            <quill-editor
              disabled
              ref="myQuillEditor"
              v-model="descripcionLaga"
              style="height: 275px"
            ></quill-editor>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <RequestTable
              ref="table"
              v-loading="loading"
              :columns="columns"
              :data="comments"
              @rtable-push-action="handlePushAction"
              ><div style="margin: 10px">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pagination.currentPage"
                  :page-size="pagination.pageSize"
                  layout="total, sizes, prev, pager, next"
                  :total="pagination.total"
                  style="margin-top: 20px"
                />
              </div>
            </RequestTable>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import { formatDate, getPaginatedItems } from "@/utils";
import RequestTable from "@/components/RabbeyTable3.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  name: "detailsInternalRequest",
  props: {
    comments: {
      type: Array
    },
    descripcionLaga: {
      type: String
    },
    descripcionCorta: {
      type: String
    }
  },
  components: {
    RequestTable,
    quillEditor
  },
  data() {
    return {
      pagination: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      loading: false,
      drawer: false,
      columns: [
        {
          prop: "Comemnts",
          label: "Comentario",
          minWidth: 150,
          fixed: true
        },
        {
          prop: "CreatedBy",
          label: "Creado Por",
          minWidth: 150,
          fixed: true,
          formatter: (row) => row.createByFullName
        },
        {
          prop: "CreatedAt",
          label: "Fecha Creación",
          minWidth: 150,
          fixed: true,
          formatter: (row) => formatDate(row.CreatedAt, "DD/MM/yyyy")
        }
      ]
    };
  },
  methods: {
    getPaginatedItems,
    handlePushAction() {},
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.isSupervisor();
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.isSupervisor();
    },
    async getEmployeeNameById(Id) {
      const url = "/api/employees/";
      await this.$http.get(url, {
        params: {
          id: Id
        }
      });
      return "REREREE";
    }
  }
};
</script>

<style></style>
